module.exports = __webpack_public_path__ + "static/media/Sub-1-By-Laws-Westbriar-Village.7e888d15.pdf";